import { useDomainTracking } from '../../shared/hooks/use-domain-tracking';
import { Card } from '../../shared/components/card';

export function DomainAdminPage() {
  const { info, allowedDomains } = useDomainTracking();

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 space-y-5">
      <Card>
        <Card.Header>Domain Tracking Information</Card.Header>
        <Card.Body className="space-y-3 text-sm">
          <div className="grid grid-cols-1 sm:grid-cols-12 gap-2">
            <div className="sm:col-span-3 font-medium text-hilevel-slate">Current Domain</div>
            <div className="sm:col-span-9 text-hilevel-slate font-mono">{info.parentDomain}</div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-12 gap-2 items-center">
            <div className="sm:col-span-3 font-medium text-hilevel-slate">Is Embedded</div>
            <div className="sm:col-span-9">
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                  info.isEmbedded
                    ? 'bg-amber-100 text-amber-800'
                    : 'bg-emerald-100 text-emerald-800'
                }`}
              >
                {info.isEmbedded ? 'Yes' : 'No'}
              </span>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-12 gap-2 items-center">
            <div className="sm:col-span-3 font-medium text-hilevel-slate">Domain Allowed</div>
            <div className="sm:col-span-9">
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                  info.allowedDomain
                    ? 'bg-emerald-100 text-emerald-800'
                    : 'bg-hilevel-red/10 text-hilevel-red'
                }`}
              >
                {info.allowedDomain ? 'Yes' : 'No'}
              </span>
            </div>
          </div>
          {info.isEmbedded && !info.allowedDomain && (
            <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
              <strong>Warning:</strong> This domain is not authorized for embedding.
            </div>
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>Allowed Domains</Card.Header>
        <ul className="divide-y divide-hilevel-border">
          {allowedDomains.map((domain) => (
            <li key={domain} className="px-5 py-2.5 text-sm text-hilevel-slate font-mono">
              {domain}
            </li>
          ))}
        </ul>
      </Card>

      <Card>
        <Card.Header>Integration Instructions</Card.Header>
        <Card.Body className="space-y-3 text-sm text-hilevel-slate">
          <p>To embed the budget calculator on an approved domain, use this iframe code:</p>
          <pre className="rounded-md bg-hilevel-slate text-hilevel-light p-4 overflow-x-auto text-xs whitespace-pre-wrap break-words">
            <code>{`<iframe
  style="border: none;"
  title="Mezzanine Floor Calculator"
  src="https://budget.iqd-pro.com"
  width="100%"
  height="1000">
</iframe>`}</code>
          </pre>
          <p>
            <strong>Note:</strong> The domain must be added to the allowed domains list before
            embedding will work. Contact support to request domain approval.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}
